import React from "react";
import Layout from "./hoc/Layout/Layout";
import { BrowserRouter as Router } from "react-router-dom";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "quill-emoji/dist/quill-emoji.css";
// import "emoji-picker-react/dist/main.css";
import "react-dates/initialize";
import "react-dates/lib/css/_datepicker.css";
import "react-quill/dist/quill.snow.css"; // ES6
import "./override.scss";
import ScrollMemory from "react-router-scroll-memory";
import NetworkDetector from "./hoc/NetworkDetector/NetworkDetector";

function App() {
  return (
    <Router>
      <ScrollMemory />
      <Layout />
    </Router>
  );
}

export default NetworkDetector(App);
